import type { FragmentType } from '@e-socna/data-layer';

import { TabsVariant } from '../../components/Tabs';

import { PersonTabs } from '../Person/Tabs';
import type {
  PersonPaths,
  PersonPage_Tabs_Person_Fragment,
} from '../Person/Tabs';

interface Props {
  readonly paths: PersonPaths;
  readonly person: FragmentType<typeof PersonPage_Tabs_Person_Fragment>;
}

export const Person = ({ paths, person }: Readonly<Props>) => (
  <PersonTabs paths={paths} person={person} variant={TabsVariant.Vertical} />
);
